import SocialUserActionTypes, * as actionDicts from "shared/social/social-user-action-types"
import { renameProperty } from "shared/imports/sharedHelperFunctions"
import { resourceGetList } from "shared/djangio/action-creators"

const { SocialUser } = DjangIO.app.social.models

const loadSocialUsers = (filterKey, model) => (entityId) =>
    entityId &&
    resourceGetList(
        SocialUser.objects,
        actionDicts.loadSocialUserActionDict,
        { [filterKey]: [entityId] },
        { entityId, model },
    )

// this is just a convenience function to be imported directly
export const loadSocialUsersFromSupporter = loadSocialUsers(
    "supporters__contains",
    DjangIO.app.grassroots.models.Supporter.__name__,
)
export const loadSocialUsersFromOrganization = loadSocialUsers(
    "public_organizations__contains",
    DjangIO.app.person.models.PublicOrganization.__name__,
)
export const loadSocialUsersFromPerson = loadSocialUsers(
    "contains_persons",
    DjangIO.app.person.models.NewPerson.__name__,
)
export const loadSocialUsersFromCommittee = loadSocialUsers(
    "committee",
    DjangIO.app.committee.models.Committee.__name__,
)

// this validates the social account and stores it in a staging area
// to eventally be saved to the database
export const validateSocialUser = (socialType, username) => {
    return (dispatch, getState) => {
        //need to hit the validation endpoint here
        return SocialUser.objects
            .get()
            .action("validate_social_user", {
                social_user_type: socialType,
                username,
            })
            .GET()
            .then(
                (validationObj) => {
                    // if the validation was successful
                    if (validationObj.was_validated) {
                        // need to add back in the socialType so we can
                        // display this on the frontend
                        validationObj.socialUserObj["social_user_type"] = socialType
                        dispatch({
                            type: SocialUserActionTypes.VALIDATED_SOCIAL_USER,
                            socialUser: validationObj.socialUserObj,
                        })
                        return validationObj.socialUserObj
                    } else {
                        // otherwise return the formatted error
                        let errorReason = undefined
                        if (validationObj.error_int) {
                            errorReason = DjangIO.app.social.models.SocialUserValidationErrors.by_value(
                                validationObj.error_int,
                            ).swal_message
                        }
                        return Promise.reject(errorReason)
                    }
                },
                (error) => Promise.reject(error),
            )
    }
}

export const clearValidatedSocialUsers = () => {
    return (dispatch, getState) => {
        return dispatch({
            type: SocialUserActionTypes.CLEAR_VALIDATED_SOCIAL_USERS,
        })
    }
}

// this takes a social account that has already been validated and
// sends it to the database to be saved
// entityId = object id
// idKey = field used to update in backend
// model = name of the model
export const createValidatedSocialUsers = (idKey, model) => (entity) => {
    // need a quick helper function to rename things in our object
    const entityId = entity.id
    return (dispatch, getState) => {
        // get the database object to save
        const validatedSocialUsers = getState().socialUser.get("validated").toJS()
        // need to map the socialUserId field on each object to being userid
        validatedSocialUsers.map((obj) => {
            renameProperty(obj, "socialUserId", "userid")
            obj[idKey] = entityId
            return obj
        })
        if (validatedSocialUsers) {
            //send it via a patch request
            return SocialUser.objects
                .bulk_update({
                    objects: validatedSocialUsers,
                })
                .PATCH()
                .then(
                    ({ objects: socialUsers }) => {
                        socialUsers.forEach((socialUser) => {
                            dispatch({
                                type: SocialUserActionTypes.ADDED_SOCIAL_USER,
                                model,
                                socialUser,
                                entityId,
                            })
                        })
                        return socialUsers
                    },
                    (error) => Promise.reject(error),
                )
        }
    }
}

/**
 * TODO This function needs a good docstring
 * @name deleteSocialUsersFromStore
 * @function
 * @param {Object} qdt - The QuorumDataType enum (TODO alos elaborate on what this is)
 * @returns {(dispatch, getState) => Promise }
 */
export const deleteSocialUsersFromStore = (qdt) => (entity, usersToDelete) => {
    return (dispatch, getState) => {
        // get the array of social user ids cued for deletion
        const entityId = entity.id
        const socialUserIdsForDeletion = usersToDelete || getState().socialUser.get("cuedForDeletion").toJS()

        return SocialUser.objects
            .get()
            .action("remove_social_users", {
                social_user_ids: JSON.stringify(socialUserIdsForDeletion),
                entity_id: JSON.stringify(entityId),
                qdt: JSON.stringify(qdt.value),
            })
            .GET()
            .then(
                (success) => {
                    dispatch({
                        type: SocialUserActionTypes.DELETED_SOCIAL_USERS,
                    })
                    return success
                },
                (error) => Promise.reject(error),
            )
    }
}

// simply remove this socialUser from the array for this entity
// and put it into a list for deletion
export const cueSocialUserForDeletion = (model) => (entityId, socialUserId, socialUserUsername) => {
    return (dispatch, getState) => {
        dispatch({
            type: SocialUserActionTypes.CUE_SOCIAL_USER_FOR_DELETION,
            entityId,
            model,
            socialUserId,
            socialUserUsername,
        })
    }
}
